// src/contexts/ArticlesContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const ArticlesContext = createContext();

const isVisibleArticle = (article) => {
	const year = Number(String(article?.date || "").slice(0, 4));
	return Number.isFinite(year) && year > 2024;
};

const sortArticlesByDateDesc = (articles) =>
	[...articles].sort((a, b) => String(b.date || "").localeCompare(String(a.date || "")));

export const useArticles = () => useContext(ArticlesContext);

export const ArticlesProvider = ({ children }) => {
    const [articles, setArticles] = useState([]);

    const fetchArticles = () => {
        fetch('https://api.northwestwind.org/articles')
            .then((response) => response.json())
            .then((data) => {
                const list = Array.isArray(data) ? data : [];
                setArticles(sortArticlesByDateDesc(list.filter(isVisibleArticle)));
            })
            .catch(console.error);
    };

    useEffect(() => {
        if (articles.length === 0) {
            fetchArticles();
        }
    }, [articles]);

    return (
        <ArticlesContext.Provider value={{ articles, setArticles, fetchArticles }}>
            {children}
        </ArticlesContext.Provider>
    );
};
